/* tslint:disable */
/* eslint-disable */
/**
 * Agrinorm Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PackagingType = {
  Bulk: 'bulk',
  ConsumerUnitsWeight: 'consumer_units_weight',
  ConsumerUnitsPieces: 'consumer_units_pieces',
  Raw: 'raw',
} as const;

export type PackagingType = (typeof PackagingType)[keyof typeof PackagingType];
